import type { RecitalCheckIn } from '~entities/recital-manager/model/types/volunteers';

import {
  CHECK_IN_HISTORY_TYPE_FILTER,
  type CheckInHistoryPersonType,
  type CheckInHistoryTypeFilter,
} from './check-in-tab.types';

export function filterCheckInsByName(
  checkIns: Array<RecitalCheckIn>,
  searchQuery: string,
): Array<RecitalCheckIn> {
  const query = searchQuery.trim().toLowerCase();
  if (!query) {
    return checkIns;
  }
  return checkIns.filter((checkIn) => {
    const name = (
      checkIn.studentName ??
      checkIn.parentName ??
      ''
    ).toLowerCase();
    return name.includes(query);
  });
}

export function getActiveHistoryFilterCount(
  typeFilter: CheckInHistoryTypeFilter,
  showFilter: string | undefined,
): number {
  return (
    (typeFilter !== CHECK_IN_HISTORY_TYPE_FILTER.ALL ? 1 : 0) +
    (showFilter !== undefined ? 1 : 0)
  );
}

export function resolveCheckInApiTypeFilter(
  typeFilter: CheckInHistoryTypeFilter,
): CheckInHistoryPersonType | undefined {
  if (typeFilter === CHECK_IN_HISTORY_TYPE_FILTER.ALL) {
    return undefined;
  }
  return typeFilter;
}

export function calculateCheckInDuration(
  checkedInAt: string,
  checkedOutAt: string,
): string {
  const start = new Date(checkedInAt);
  const end = new Date(checkedOutAt);
  const durationMs = end.getTime() - start.getTime();
  const hours = Math.floor(durationMs / (1000 * 60 * 60));
  const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
}
